import script from "./Confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./Confirm.vue?vue&type=script&setup=true&lang=js"

import "./Confirm.vue?vue&type=style&index=0&id=57ad3116&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ad3116"]])

export default __exports__